































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class CmFooter extends Vue {
  @Prop() private msg!: string;
}
